// removed by extract-text-webpack-plugin
module.exports = {"portal-notifications-wrapper":"portal-notifications-wrapper___ZvZy1","read-msg":"read-msg___3rs7T","portal-notifications-card":"portal-notifications-card___3Z-rz"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/notification-sidenav/notifications-tab.module.scss
// module id = 1006
// module chunks = 82